/**
 * Polyfill for Array.prototype.findLastIndex
 * Searches array from the end towards the beginning and returns the index of the first element
 * that satisfies the provided testing function.
 */
/* eslint-disable no-extend-native */
if (!Array.prototype.findLastIndex) {
  Array.prototype.findLastIndex = function (predicate, thisArg) {
    if (this == null) {
      throw new TypeError('Array.prototype.findLastIndex called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }

    const o = Object(this);
    const len = o.length || 0;

    // Iterate from the end of the array
    let k = len - 1;
    while (k >= 0) {
      const kValue = o[k];
      // Evaluate the predicate function
      if (predicate.call(thisArg, kValue, k, o)) {
        return k;
      }
      k--;
    }

    // No element passed the predicate test
    return -1;
  };
}
/* eslint-enable no-extend-native */

/**
 * Add any additional polyfills here
 */
